import { TFileBatchModel } from 'types/file';
import { TPicture } from 'types/picture';

import { apiRequest } from '@utils/apiRequest';

type TPictureEmpty = string;

export async function actionImages<T extends 'saveFileBatch' | 'removeFileBatch'>(
    model: TFileBatchModel,
    entityId: number,
    imageFiles: number[] | File[] | null,
    type: T,
    onProgress?: (percentage: number, file: File) => void
) {
    const key = typeof imageFiles?.[0] === 'number' ? 'ids' : 'pictures';

    const responseImageData = await apiRequest(async (api, crm_id) => {
        return api[type](
            {
                crm_id,
                model,
                id: entityId,
                defaultID: null,
                ...(imageFiles ? { [key]: imageFiles } : []),
            },
            onProgress
        );
    });

    return (responseImageData?.data?.data ??
        responseImageData?.data ??
        []) as unknown as T extends 'saveFileBatch' ? TPicture[] : TPictureEmpty[];
}

export const uploadImageBatch = async (
    model: TFileBatchModel,
    entityId: number,
    imageFiles: File[],
    onProgress?: (percentage: number, file: File) => void
) => {
    return await actionImages(model, entityId, imageFiles, 'saveFileBatch', onProgress);
};

export const removeImageBatch = async (
    model: TFileBatchModel,
    entityId: number,
    imageIds: number[]
) => {
    return await actionImages(model, entityId, imageIds, 'removeFileBatch');
};
